import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthService from "../../services/auth.service";


/* =========================================================
   LOGIN
========================================================= */

export const userLogin = createAsyncThunk(
  "auth/userLogin",
  async (item, thunkAPI) => {
    try {
      const data = await AuthService.login(item);

      console.log("AUTH SERVICE RESPONSE:", data);

      return data;

    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
        error.message ||
        "Login failed"
      );
    }
  }
);


/* =========================================================
   REGISTER
========================================================= */

export const register = createAsyncThunk(
  "auth/register",
  async (item, thunkAPI) => {
    try {
      const data = await AuthService.register(item);
      return data;

    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
        error.message ||
        "Registration failed"
      );
    }
  }
);


export const activateMyAccountFromWallet = createAsyncThunk(
  "auth/activateMyAccountFromWallet",
  async (item, thunkAPI) => {
    try {
      const data = await AuthService.activateMyAccountFromWallet(item);
      return data;

    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
        error.message ||
        "Registration failed"
      );
    }
  }
);


/* =========================================================
   LOGOUT
========================================================= */

export const logout = createAsyncThunk(
  "auth/logout",
  async () => {

    // Clear localStorage
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("authUser");
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");

    // Clear sessionStorage
    sessionStorage.removeItem("user");
    sessionStorage.removeItem("accessToken");
    sessionStorage.removeItem("refreshToken");
    sessionStorage.removeItem("isLoggedIn");

    return true;
  }
);


/* =========================================================
   PROFILE
========================================================= */

export const getProfile = createAsyncThunk(
  "auth/getProfile",
  async (_, thunkAPI) => {
    try {

      const response = await AuthService.getProfile();

      return response.data;

    } catch (error) {

      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
        error.message
      );
    }
  }
);


/* =========================================================
   INITIAL USER
========================================================= */

const storedUser = JSON.parse(
  sessionStorage.getItem("user") || "null"
);


/* =========================================================
   INITIAL STATE
========================================================= */

const initialState = {
  loading: false,
  error: "",
  authdata: [],
  verificationData: null,

  user: storedUser,

  isAuthenticated: !!storedUser,

  changeMobileLoading: false,
  changeEmailLoading: false,

  changeMobileError: null,
  changeEmailError: null,
};


/* =========================================================
   SLICE
========================================================= */

const authSlice = createSlice({
  name: "auth",

  initialState,

  reducers: {},

  extraReducers: (builder) => {
    builder

      /* ================= LOGIN ================= */

      .addCase(userLogin.pending, (state) => {
        state.loading = true;
        state.error = "";
      })

      .addCase(userLogin.fulfilled, (state, action) => {
        state.loading = false;
        state.error = "";

        const response = action.payload;

        /*
        API RESPONSE:

        {
          status: 1,
          data: {
            userId,
            name,
            accessToken,
            refreshToken
          }
        }
        */

        const userData = response?.data;

        if (userData) {

          const {
            accessToken,
            refreshToken,
            password,
            ...user
          } = userData;

          // Redux user
          state.user = user;

          // Authenticated
          state.isAuthenticated = true;

        } else {

          state.user = null;
          state.isAuthenticated = false;
          state.error = "Invalid login response";

        }
      })

      /* ================= LOGIN FAILED ================= */

      .addCase(userLogin.rejected, (state, action) => {
        state.loading = false;

        state.error =
          action.payload ||
          "Login failed";

        state.user = null;

        state.isAuthenticated = false;
      })


      /* ================= LOGOUT ================= */

      .addCase(logout.pending, (state) => {
        state.loading = true;
        state.error = "";
      })

      .addCase(logout.fulfilled, (state) => {
        state.loading = false;
        state.error = "";
        state.user = null;
        state.isAuthenticated = false;
      })

      .addCase(logout.rejected, (state, action) => {
        state.loading = false;

        state.error = action.payload;
      });
  },
});


export default authSlice.reducer;